import { get_api_path } from "services/api";
import { getBinaryFromFile } from "utils/fileUtils";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("activity/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(activity_id) {
  const url = get_api_path("activity/detail", {}, { activity_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(activity_id) {
  const url = get_api_path("activity/delete", {}, { activity_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(activity_id, data) {
  const url = get_api_path("activity/update", {}, { activity_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(data) {
  const url = get_api_path("activity/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create_media(activity_id, file) {
  const headers = { 'X-Name': file.name, 'Content-Type' : file.type };
  const data = await getBinaryFromFile(file);
  const url = get_api_path("activity/media/create", null, { activity_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data, { headers });
  const { model } = response.data.result;
  return model;
}

export async function del_media(activity_id, asset_id) {
  const url = get_api_path("activity/media/delete", {}, { activity_id, asset_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};